import * as React from "react";
type Props = {
  className?: string,
};
function SvgPlusCircle({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-plus-circle"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM13 11V7H11V11H7V13H11V17H13V13H17V11H13Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgPlusCircle;
